<div class="modal-styles">
  <div id="message">
    The account you're trying to link has been temporarily locked due to multiple login attempts.
    Please try again in {{data.expiryInMinutes}} {{data.expiryInMinutes == 1 ? 'minute.' : 'minutes.'}}
  </div>
  <div>
    <br>Need a hand? Please call us on {{commonDataService.siteDetails.supportNumber}} and we’ll be happy to help.
  </div>
</div>
